import { useQuery } from '@tanstack/react-query';

export const useGetVoWifiConfig = (
  state: string,
  services: any,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ['vowifi_get_address', state],
    queryFn: () => services.voWifiGetAddress({ state }),
    enabled,
    refetchOnWindowFocus: false,
    retry: 0,
  });
};
